import { useEffect, useState } from "react";

/** Ticks down every second until the given ISO expiration is reached.
 *  Returns 0 if `expiresAt` is falsy or already past. */
export default function useCountdown(expiresAt) {
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    if (!expiresAt) {
      setSecondsLeft(0);
      return;
    }
    const end = new Date(expiresAt).getTime();
    const tick = () => setSecondsLeft(Math.max(0, Math.floor((end - Date.now()) / 1000)));
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, [expiresAt]);

  return secondsLeft;
}
